import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TabSessionService } from '@app/shared/http-service/tab-session.service';
import { Constants } from '@app/shared/models/constants';
import { TenantResolverService } from '@app/shared/tenant-resolver.service';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';

@Injectable()
export class HttpTenantAuthorizationInterceptor implements HttpInterceptor {
	constructor (private tenantResolverService: TenantResolverService, private authStorage: OAuthStorage, private tabSessionservice: TabSessionService) { }

	intercept (request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const tenant = this.tenantResolverService.getTenantIdentity();
		const token = localStorage.getItem(Constants.AccessTokenStorageKey);
		const header = `${ Constants.AuthorizationHeaderPrefixKey } ${ token }`;

		let headers = request.headers.set(Constants.TenantHeaderKey, tenant);
		if (token) {
			headers = headers.set(Constants.AuthorizationHeaderKey, header);
		}

		headers = headers.set(Constants.TabSessionHeaderKey, this.tabSessionservice.getSessionId());

		request = request.clone({
			headers: headers
		});
		return next.handle(request);
	}
}